<mat-dialog-content class="mat-typography">
    <aw-wizard #wizard>
        <aw-wizard-step [stepTitle]="'Paso 1'">
            <div class="centered-content">
                <div>

                    <div class="form-horizontal">

                        <h4 class="form-signin-heading">B&uacute;squeda de Usuario FileDOM</h4>
                        <br>
                        <div class="form-group">

                            <div class="col-md-9">


                                <form [formGroup]="userform">
                                    <mat-form-field class="input-form">
                                        <input matInput name="busc_rut" id="busc_rut" type="text"
                                            formControlName="busc_rut" formatRut class="form-control" placeholder="RUT">
                                        <mat-error *ngIf="userform.controls?.busc_rut.hasError('invalidRut') ">
                                            Este rut es <strong>invalido</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </form>


                            </div>
                        </div>
                        <!-- <button type="submit" class="btn btn-primary btn-md">Buscar <span class="glyphicon glyphicon-user" aria-hidden="true"></span></button> -->
                    </div>



                </div>
                <br>
                <div class="btn-group">
                    <button type="button" class="btn btn-primary" (click)="buscarUsuario()"
                        [disabled]="!userform.valid">Buscar <span class="glyphicon glyphicon-user"
                            aria-hidden="true"></span></button>
                </div>
            </div>
        </aw-wizard-step>
        <aw-wizard-step [stepTitle]="'Paso 2'">



            <form [formGroup]="form">
                <div class="centered-content">
                    <div>
                        <div class="form-horizontal">
                            <h4 class="form-signin-heading">Usted no se encuentra registrado en FileDOM, ingrese sus
                                datos en el siguiente formulario.</h4>
                            <br />

                            <div class="form-group">



                                <label for="rut" class="col-md-3 control-label mt5">RUT</label>
                                <div class="col-md-5">
                                    <input name="rut" id="rut" formControlName="rut" formatRut class="form-control mt5"
                                        placeholder="Rut" disabled>
                                </div>

                            </div>
                            <div class="form-group">
                                <label for="nombres" class="col-md-3 control-label mt5">Nombres(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input name="nombres" id="nombres" type="text" formControlName="nombres"
                                        class="form-control mt5" placeholder="Nombres">
                                </div>

                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['nombres'].invalid || form.controls['nombres'].invalid && (form.controls['nombres'].dirty || form.controls['nombres'].touched)">
                                    <div *ngIf="form.controls['nombres'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['nombres'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="apaterno" class="col-md-3 control-label mt5">Apellido Paterno(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="apaterno" id="apaterno"
                                        formControlName="apellidoP" placeholder="Apellido Paterno">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['apellidoP'].invalid || form.controls['apellidoP'].invalid && (form.controls['apellidoP'].dirty || form.controls['apellidoP'].touched)">
                                    <div *ngIf="form.controls['apellidoP'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['apellidoP'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="amaterno" class="col-md-3 control-label mt5">Apellido Materno(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="amaterno" id="amaterno"
                                        formControlName="apellidoM" placeholder="Apellido Materno">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['apellidoM'].invalid || form.controls['apellidoM'].invalid && (form.controls['apellidoM'].dirty || form.controls['apellidoM'].touched)">
                                    <div *ngIf="form.controls['apellidoM'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['apellidoM'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="profesion" class="col-md-3 control-label mt5">Profesión</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="profesion" id="profesion"
                                        formControlName="profesion" placeholder="Profesón (opcional)">
                                </div>
                            </div>


                            <div class="form-group">
                                <label for="dir_calle" class="col-md-3 control-label mt5">Direcci&oacute;n: Calle(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="dir_calle" id="dir_calle"
                                        formControlName="calle" placeholder="Calle">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['calle'].invalid || form.controls['calle'].invalid && (form.controls['calle'].dirty || form.controls['calle'].touched)">
                                    <div *ngIf="form.controls['calle'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['calle'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="dir_num" class="col-md-3 control-label mt5">Direcci&oacute;n: Numero(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">


                                    <input type="text" class="form-control mt5" name="dir_num" maxlength="50"
                                        formControlName="numero" id="dir_num" placeholder="Número" inputmode=”numeric”
                                        pattern="[0-9]*">



                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['numero'].invalid || form.controls['numero'].invalid && (form.controls['numero'].dirty || form.controls['numero'].touched)">
                                    <div *ngIf="form.controls['numero'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['numero'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['numero'].hasError('pattern')">
                                        Solo se permiten caracteres <strong>numéricos</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="dir_compl" class="col-md-3 control-label mt5">Direcci&oacute;n:
                                    Complemento</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="dir_compl" id="dir_compl"
                                        formControlName="complemento"
                                        placeholder="Complemento (Ej: Depto 123, Of. 123)">
                                </div>
                            </div>

                            
                            <div class="form-group">
                                <label for="comuna" class="col-md-3 control-label mt5">Región(<span
                                        style="color:red;">*</span>)</label>


                                <div class="col-md-5">
                                    <select class="form-control mt5" name="region" id="region" formControlName="region" (change)="cambiarComunas($event)">
                                        <option *ngFor="let region of regiones?.data; let i = index;" [value]="region.fieldData.region">
                                            {{region.fieldData.region}}
                                        </option>
                                    </select>
                                    <div class="alert alert-danger"
                                        *ngIf="btnclicked && form.controls['region'].invalid || form.controls['region'].invalid && (form.controls['region'].dirty || form.controls['region'].touched) ">
                                        <div *ngIf="form.controls['region'].hasError('required')">
                                            Campo Requerido.
                                        </div>
                                        <div *ngIf="form.controls['region'].hasError('minlength')">
                                            Ingresaste un valor demasiado corto.
                                        </div>
                                    </div>
                                </div>



                            </div>
                            <div class="form-group">


                                <label for="comuna" class="col-md-3 control-label mt5">Comuna(<span
                                        style="color:red;">*</span>)</label>

                                <div class="col-md-5">
                                    <select class="form-control mt5" name="comuna" id="comuna"
                                        [disabled]="comunasFinal?.length == 0" formControlName="comuna">
                                        <option>Seleccionar</option>
                                        <option *ngFor="let comuna of comunasFinal; let i = index;">
                                            {{comuna.fieldData.COM_Nombre}}</option>
                                    </select>


                                </div>



                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['comuna'].invalid || form.controls['comuna'].invalid && (form.controls['comuna'].dirty || form.controls['comuna'].touched) ">
                                    <div *ngIf="form.controls['comuna'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['comuna'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>


                                
                            </div>



                            <div class="form-group">
                                <label for="email" class="col-md-3 control-label mt5">Email(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="email" class="form-control mt5" name="email" id="email"
                                        formControlName="email" placeholder="Email" size="100">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['email'].invalid || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)">
                                    <div *ngIf="form.controls['email'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['email'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['email'].hasError('email')">
                                        Debes ingresar un email válido.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="telefono" class="col-md-3 control-label mt5">Tel&eacute;fono(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5 mt5">

                                    <div class="input-group prefix">
                                        <span class="input-group-addon">+56</span>
                                        <input type="text" class="form-control" name="telefono" id="telefono"
                                            formControlName="telefono" inputmode=”numeric” pattern="[0-9]*"
                                            placeholder="Tel&eacute;fono" maxlength="9">
                                    </div>
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['telefono'].invalid || form.controls['telefono'].invalid && (form.controls['telefono'].dirty || form.controls['telefono'].touched)">
                                    <div *ngIf="form.controls['telefono'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['telefono'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['telefono'].hasError('maxlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['telefono'].hasError('pattern')">
                                        Solo se permiten caracteres <strong>numéricos</strong>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="pass1" class="col-md-3 control-label mt5">Contrase&ntilde;a(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5" formGroupName="passwords">
                                    <input type="password" class="form-control mt5" name="pass1" id="pass1"
                                        formControlName="password" placeholder="Contrase&ntilde;a" size="40">
                                </div>



                            </div>
                            <div class="form-group">
                                <label for="pass2" class="col-md-3 control-label mt5">Repita contrase&ntilde;a(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5" formGroupName="passwords">
                                    <input type="password" class="form-control mt5" name="pass2" id="pass2"
                                        formControlName="repassword" placeholder="Contrase&ntilde;a">
                                </div>


                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && (form.controls.passwords.errors?.mismatchedPasswords || form.controls.passwords.value.repassword.length<4||form.controls.passwords.value.password.length<4) || (form.controls.passwords.value.repassword.length<4||form.controls.passwords.value.password.length<4) && (form.controls.passwords.dirty || form.controls.passwords.touched)">
                                    <div *ngIf="form.controls.passwords.errors?.mismatchedPasswords">
                                        Las contraseñas deben coincidir.
                                    </div>
                                    <div
                                        *ngIf="form.controls.passwords.value.repassword.length<4||form.controls.passwords.value.password.length<4">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>
                            <!-- <button type="submit" class="btn btn-primary btn-md">Registrarse <span class="glyphicon glyphicon-user" aria-hidden="true"></span></button> -->
                        </div>
                    </div>
                    <div class="btn-group">
                        <div class="col-md-2"><button type="button" class="btn btn-primary" awPreviousStep><span
                                    class="glyphicon glyphicon glyphicon-arrow-left" aria-hidden="true"> </span> Volver
                            </button></div>
                        <div class="col-md-2"></div>
                        <div class="col-md-2"><button type="button" class="btn btn-primary" (click)="register(); "><span
                                    class="glyphicon glyphicon-user" aria-hidden="true"> </span>
                                Registrarse </button></div>
                    </div>
                </div>
            </form>
        </aw-wizard-step>
        <aw-wizard-step [stepTitle]="'Finalizar'">
            <div class="centered-content">
                <div>
                    <div class="form-horizontal">
                        <h4 class="form-signin-heading">Su cuenta de usuario ha sido creada exitosamente. Un correo de
                            verificaci&oacute;n ha sido enviado a: {{form.get('email').value}}.</h4>
                    </div>
                </div>

                <div class="btn-group">

                    <div class="col-md-2"><button type="button" class="btn btn-primary" (click)="finishRegister()"><span
                                class="glyphicon glyphicon glyphicon-arrow-right" aria-hidden="true"></span> Finalizar
                        </button></div>
                </div>
            </div>
        </aw-wizard-step>

    </aw-wizard>
</mat-dialog-content>